export interface ITrackingEvent {
  event: string
  eventCategory?: string
  // eslint-disable-next-line
  [key: string]: any
}

const BASE_EVENT = {
  event: 'user_interaction', // Event name configured in GTM
  eventCategory: 'WestfieldPlus',
}

const signUpStepLabels = [
  'Step 1 Submit email',
  'Step 2 OTP verification',
  'Step 3 Onboarding Personal Details',
]
export const signUpSteps = (step: number): ITrackingEvent => {
  return {
    ...BASE_EVENT,
    eventAction: 'Sign Up',
    eventLabel: `Successful Sign Up - New Westfield User - ${
      signUpStepLabels[step - 1]
    }`,
  }
}

const createPasswordStepLabels = [
  'Step 1 Submit email',
  'Step 2 OTP verification',
  'Step 3 Accept terms',
  'Step 4 Onboarding Personal Details',
  'Continue',
]
export const createPasswordSteps = (step: number): ITrackingEvent => {
  return {
    ...BASE_EVENT,
    eventAction: 'Create Password',
    eventLabel: createPasswordStepLabels[step - 1],
  }
}

export const logError = (action: string, error: string): ITrackingEvent => {
  return {
    ...BASE_EVENT,
    eventAction: action,
    eventLabel: error,
  }
}

const verificationCodeLabels = ['continue', 'resend verification code']

export const trackPSteps = (vcodeLabel: number): ITrackingEvent => {
  return {
    ...BASE_EVENT,
    eventAction: 'click',
    eventLabel: verificationCodeLabels[vcodeLabel - 1],
  }
}

export const trackContinueLogin = (): ITrackingEvent => {
  return {
    ...BASE_EVENT,
    eventAction: 'Login',
    eventLabel: 'Continue Login',
  }
}

export const trackForgotPassword = (): ITrackingEvent => {
  return {
    ...BASE_EVENT,
    eventAction: 'Forgot Password',
    eventLabel: 'Forgot Password',
  }
}

export const trackSignUpLink = (): ITrackingEvent => {
  return {
    ...BASE_EVENT,
    eventAction: 'Signup Link',
    eventLabel: 'Signup Link',
  }
}

export const trackContinueSignup = (): ITrackingEvent => {
  return {
    ...BASE_EVENT,
    eventAction: 'Signup',
    eventLabel: 'Continue Signup',
  }
}

export const trackGoogleSignup = (): ITrackingEvent => {
  return {
    ...BASE_EVENT,
    eventAction: 'Social',
    eventLabel: 'Google',
  }
}

export const trackAppleSignup = (): ITrackingEvent => {
  return {
    ...BASE_EVENT,
    eventAction: 'Social',
    eventLabel: 'Apple',
  }
}

export const trackGoToLoginLink = (): ITrackingEvent => {
  return {
    ...BASE_EVENT,
    eventAction: 'Go to Login',
    eventLabel: 'Go to Login',
  }
}

export const trackVerificationCode = (vcodeLabel: number): ITrackingEvent => {
  return {
    ...BASE_EVENT,
    eventAction: 'Verification Code',
    eventLabel: verificationCodeLabels[vcodeLabel - 1],
  }
}

export const trackBackButton = (): ITrackingEvent => {
  return {
    ...BASE_EVENT,
    eventAction: 'Back Button',
    eventLabel: 'Back Button',
  }
}
